import BaseModelAPI from '../BaseModelAPI';

export default class ControlCardList extends BaseModelAPI {

	static entity = 'controlcardlist'
	static entityName = 'controlcard';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
